import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithAccountId } from '@mews-commander/types';
import { IconName } from '@optimus-web/core';
import { useDeleteConfirmationDialog } from '@mews-commander/ui';
import { PaymentsTablesActionsMenu } from '../PaymentsTablesActionsMenu';
import { useCancelSettlement } from './queries';

interface Props extends WithAccountId {
    settlementId: string;
    isPreauthorization: boolean;
}

export const SettlementsActionsMenu = ({ accountId, settlementId, isPreauthorization }: Props) => {
    const cancelSettlement = useCancelSettlement({ accountId });
    const { confirmationDialog, openConfirmationDialog } = useDeleteConfirmationDialog({
        deleteAction: async () => {
            await cancelSettlement.mutateAsync({ isPreauthorization, settlementId });
        },
        renderContent: () =>
            lt(isPreauthorization ? 'CancelSettlementQuestionPreauth' : 'CancelSettlementQuestionPayment'),
        title: lt(isPreauthorization ? 'CancelSettlementQuestionTitlePreauth' : 'CancelSettlementQuestionTitlePayment'),
        primaryButtonTextKey: isPreauthorization ? TextKey.CancelPreauthorization : TextKey.CancelPayment,
    });
    const actions = [
        {
            key: 'cancel',
            icon: IconName.CrossClose,
            text: lt('Cancel'),
            onClick: openConfirmationDialog,
        },
    ];
    return (
        <>
            <PaymentsTablesActionsMenu actions={actions} />
            {confirmationDialog}
        </>
    );
};
